export enum CMSType {
  WORDPRESS = "Wordpress",
  SHOPIFY = "Shopify",
  LIGHTSPEED = "Lightspeed",
  API = "API",
}
